export default "__VITE_ASSET__BVssMefk__"